<p>
  validate-user works!
</p>
